<template>
  <b-container fluid v-if="session"
    ><b-row class="tsny_border-top"
      ><b-col class="col-xl-2 col-sm-6 col-padding col-filled"
        ><b-row v-if="courseId"
          ><b-col
            ><h2 class="tsny_header">
              Last Session
            </h2></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <div class="tsny_text">
              {{ sessionDate }}
            </div>
            <div class="tsny_text" v-if="session.date">
              {{ sessionTime }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-xl-4 col-sm-6 col-padding col-filled">
        <b-row>
          <b-col>
            <h3 class="tsny_text-bold">Session Report</h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="tsny_text">{{ session.report }}</div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-xl-3 col-sm-6 col-padding"
        ><b-row>
          <b-col>
            <h3 class="tsny_text-bold">Assignment</h3>
          </b-col> </b-row
        ><b-row>
          <b-col>
            <div class="tsny_text">{{ session.assignment }}</div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-xl-3 col-sm-6 col-padding tsny_text-mid text-right">
        <b-row class="mb-2">
          <b-col>
            <div class="tsny_link">
              <span class="link_margin">Download Report</span
              ><i class="fa fa-download fa-fw tsny_icon-margin"></i>
            </div>
          </b-col> </b-row
        ><b-row class="mb-2" v-if="courseId">
          <b-col>
            <div class="tsny_link" @click="toSessionReports">
              <span class="link_margin">Past Sessions</span
              ><i class="far fa-calendar-alt fa-fw tsny_icon-margin"></i>
            </div>
          </b-col> </b-row
        ><b-row v-if="courseId">
          <b-col>
            <div class="tsny_link link_margin" @click="toQuestionBank()">
              Question Bank
            </div>
          </b-col> </b-row
        ><b-row class="mb-2" v-if="showAdminFunctions">
          <b-col>
            <div class="tsny_link" @click="$emit('update-report')">
              <span class="link_margin">Edit Report</span
              ><i class="fa fa-edit fa-fw tsny_icon-margin"></i>
            </div>
          </b-col> </b-row
        ><b-row v-if="showAdminFunctions">
          <b-col>
            <div class="tsny_link" @click="$emit('delete-report')">
              <span class="link_margin">Delete Report</span
              ><i class="fa fa-trash fa-fw tsny_icon-margin"></i>
            </div>
          </b-col>
        </b-row> </b-col
    ></b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import Constants from "../../services/Constants";

export default {
  name: "SessionReport",
  props: {
    courseId: {
      type: String,
      default: null
    },
    session: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({ isStaff: StoreConstants.GETTERS.IS_STAFF }),
    isPlaceholder() {
      return (
        this.session.report === Constants.SESSION_REPORTS.REPORT_PLACEHOLDER &&
        this.session.assignment ===
          Constants.SESSION_REPORTS.ASSIGNMENT_PLACEHOLDER
      );
    },
    showAdminFunctions() {
      return !this.courseId && this.isStaff && !this.isPlaceholder;
    },
    sessionDate: function() {
      return this.session.date
        ? moment(this.session.date).format("MMMM DD, YYYY")
        : "TBD";
    },
    sessionTime: function() {
      return this.session.startTime && this.session.endTime
        ? `${moment(this.session.startTime, "h:mm a").format("hA")}-${moment(
            this.session.endTime,
            "h:mm a"
          ).format("hA")}`
        : "Time TBD";
    }
  },
  methods: {
    toSessionReports: function() {
      this.$router.push({
        name: "SessionReports",
        params: { id: this.courseId }
      });
    },
    toQuestionBank: function() {
      this.$router.push({
        name: "QuestionBank",
        params: { id: this.courseId }
      });
    }
  }
};
</script>

<style scoped>
.col-padding {
  padding: 25px;
}

.col-filled {
  background-color: #f8f8f8;
}

.text-right {
  text-align: right;
  padding-right: 0;
}

.link_margin {
  margin-right: 30px;
}

.tsny_icon-margin {
  margin-left: -16px;
  width: 17px;
}
</style>
